/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import { Button } from "../../../../../components/Component";
import Swal from "sweetalert2";
const CpDashdataUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    const month1 = ["Test", "Quarter 4 (Jan- Mar)", "FEBRUARY", "MARCH", "Quarter 1 (Apr- Jun)", "May", "JUNE", "Quarter 2 (Jul-Sep)", "AUGUST", "SEPTEMBER", "Quarter 3 (Oct- Dec)", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        activeStatus: "O",
        employmentId: 0,
        employmentRefId: 0
    });
   
    const getdata = async () => {

        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            MonthId: Number(props.month),
            EmploymentRefCPId: 13,
            YearId: Number(props.year),
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/DashdataCP', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                   // //console.log(data)
                    if (data !== "No data") {
                        setFormData({
                            ...formData,
                            activeStatus: data.activeStatus,
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });

                    } else {
                        setFormData({
                            ...formData,
                            activeStatus: "O",
                            employmentId: data.employmentId,
                            employmentRefId: data.employmentRefId
                        });
                    }

                    setload(false)
                })


    }

    /*Recheck function Start*/

    const Recheck = async (emp) => {


        const sendData = {
            EmploymentId: Number(emp),

        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/Reopen', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === 'Done') {
                        Swal.fire({
                            icon: "success",
                            title: "Done",
                            text: "Send to Recheck Successfully",
                            focusConfirm: false,
                        });
                    }


                })


    }

    /*Recheck function End*/

    /*Edit Recheck function Start*/
    const Editcheck = async () => {

        Swal.fire({
            icon: "error",
            title: "Form is Not Submitted",
            focusConfirm: false,
        });

    }
    /*Edit Recheck function End*/
    const check = async () => {
        if (Number(props.month) > 0) {
        const sendData = {
            EmploymentRefCPId: Number(13),
            UserId: Number(localStorage.getItem("userId")),
            YearId: Number(props.year),
            MonthId: Number(props.month)
        }
        //console.log("sendData", sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/CP/CheckdraftCP2', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())

            .then(
                data => {
                   // //console.log(data)
                    if (data === "NO") {
                        window.location.pathname = "cpform"
                    }
                    else if (data === "Previous Month Data Not Submitted") {
                        Swal.fire({
                            icon: "error",
                            title: "Data Not Submitted",
                            text: "Previous Quarter Data Not Submitted",
                            focusConfirm: false,
                        });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: month1[data.monthId] + " " + data.yearId,
                            text: month1[data.monthId] + " " + data.yearId + " Data of " + data.table + " is Already in Draft",
                            focusConfirm: false,
                        });
                    }

                })

        } else {
            Swal.fire({
                icon: "error",
                title: "Quarter not selected",
                text: "Please select Quarter.",
                focusConfirm: false,
            });
        }
    };

    const viewpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
        sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
        window.location.pathname = "cpviewform"

    };

    const Editpage = async () => {

        sessionStorage.setItem("employmentId", formData.employmentId)
        sessionStorage.setItem("EmploymentRefId", formData.employmentRefId)
        window.location.pathname = "cpeditform"

    };

    useEffect(() => {
        if (Number(props.year) > 0 && Number(props.month) > 0) {
            getdata()
        }

    }, [props.year, props.month])

    return (

        !load && (
            <> {localStorage.getItem("urole") === "16" ? (
                <Fragment>
                <td>
                    {formData.activeStatus === "A" ? <> <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>  Draft</b></> : formData.activeStatus === "S" ? <> <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> Submitted</b></> : <> <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>  <b style={{ fontSize: 18 }}> Open</b></>}
                </td>
                <td>
                    {formData.activeStatus === "A" ? <Button onClick={(ev) => {
                        ev.preventDefault();
                        Editpage()
                    }} style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                        <b style={{ fontSize: 18 }}> Edit <em className="icon ni ni-pen2"></em> </b>
                    </Button> : formData.activeStatus === "S" ? <Button
                        color="success" onClick={(ev) => {
                            ev.preventDefault();
                            viewpage()

                        }} >
                        <b style={{ fontSize: 18 }}>View <em className="icon ni ni-eye-fill"></em></b>
                    </Button> : <Button onClick={(ev) => {
                        ev.preventDefault();
                        check()
                    }} style={{ backgroundColor: "#e85347", color: "white" }} >
                        <b style={{ fontSize: 18 }}> Add <em className="icon ni ni-property-add"></em>  </b>
                    </Button>}

                    </td>
                {formData.activeStatus === "S" ? (
                        <td>
                            <Button color="success" onClick={() => Recheck(formData.employmentId)}><b style={{ fontSize: 18 }}>Request Edit   <em  class="icon ni ni-check-circle-cut"></em> </b> </Button>
                        </td>
                    ) :(
                        <td>
                            <Button color="dark" onClick={() => Editcheck()}><b style={{ fontSize: 18 }}>Request Edit <em className="icon ni ni-check-circle-cut"></em></b></Button>
                        </td>
                    )}
                </Fragment>
            ) : (
                <Fragment>
                <td>
                    {formData.activeStatus === "A" ? <> <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>  <b style={{ fontSize: 18 }}>  Draft</b></> : formData.activeStatus === "S" ? <> <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>  <b style={{ fontSize: 18 }}> Submitted</b></> : <> <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>  <b style={{ fontSize: 18 }}> Open</b></>}
                </td>
                <td>
                    {formData.activeStatus === "A" ? <Button onClick={(ev) => {
                        ev.preventDefault();
                        Editpage()
                    }} style={{ backgroundColor: "#f9db7b", color: "white", borderColor: "white" }} >
                        <b style={{ fontSize: 18 }}> Edit <em className="icon ni ni-pen2"></em> </b>
                    </Button> : formData.activeStatus === "S" ? <Button
                        color="success" onClick={(ev) => {
                            ev.preventDefault();
                            viewpage()

                        }} >
                        <b style={{ fontSize: 18 }}>View <em className="icon ni ni-eye-fill"></em></b>
                    </Button> : <Button onClick={(ev) => {
                        ev.preventDefault();
                        check()
                    }} style={{ backgroundColor: "#e85347", color: "white" }} >
                        <b style={{ fontSize: 18 }}> Add <em className="icon ni ni-property-add"></em>  </b>
                    </Button>}

                </td>
                </Fragment>
            )}
            </>
        )
    );
};

export default CpDashdataUpdate;
